import React from 'react';
import Page from '../../layout/Page';
import Details from './Details';
import ToS from '../ToS';
import ThemeSelector from '../../layout/ThemeSelector';



const Account = ({ ...props }) => {
    return (
        <Page
            title='Account'
            tabs
        >
            <Details tab='User Details' />

            <ToS tab='Terms Of Service' />
        </Page >
    );
}

export default Account;